import { css } from '@emotion/react'

export const transitionSpeed = {
  extraSlow: 500,
  slow: 300,
  normal: 250,
  fast: 200,
}

export const transitionEase = {
  ease: 'ease',
  easeOut: 'ease-out',
  easeInOut: 'ease-in-out',
  cubicBezierSmooth: 'cubic-bezier(0.666, 0, 0.333, 1)',
}

export const primaryTransitionEase = transitionEase.cubicBezierSmooth
export const primaryTransitionSpeed = transitionSpeed.slow

// Assign styles to image's parent, like: <StyledDiv css={animations.zoomNestedImage} />
// Images within will zoom on parent hover
export const zoomNestedImage = css`
  overflow: hidden;
  position: relative;

  img {
    transition: transform 0.3s cubic-bezier(0.666, 0, 0.333, 1);
  }

  &:hover {
    img {
      transform: scale(1.1);
    }
  }
`

// Assign styles to interactive element to add an animated line underneath on hover
// Line will animate from 0 to 100% width
export const linkHover = (color: string, height = '1px') => css`
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    width: 0;
    height: ${height};
    background: ${color};
    transition: width ${primaryTransitionSpeed}ms ${transitionEase.easeOut};
  }

  &:hover {
    &::after {
      width: 100%;
    }
  }
`

export const animations = {
  transitionSpeed,
  transitionEase,
  zoomNestedImage,
  linkHover,
}
